export const FIRST_PAGE_INDEX = 1
export const MAX_PAGE_INDEX = 5
